import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	compass: {
		id: 'issue-field-service-entity.detail-content.compass.do-not-translate',
		defaultMessage: 'Compass',
		description: 'Compass, which is the name of an Atlassian product. Do not translate this.',
	},
	description: {
		id: 'issue-field-service-entity.detail-content.description',
		defaultMessage: 'Description',
		description: 'Description for service',
	},
	emptyDescription: {
		id: 'issue-field-service-entity.detail-content.empty-description',
		defaultMessage: 'None',
		description: 'Description for service if none is specified',
	},
	tier: {
		id: 'issue-field-service-entity.detail-content.tier',
		defaultMessage: 'Tier',
		description: 'Tier of the service',
	},

	serviceOwners: {
		id: 'issue-field-service-entity.detail-content.service-owners',
		defaultMessage: 'Service Owners',
		description: 'Owners of the service',
	},
});
